import React from 'react';

import { AutoMode as AutoLayoutIcon, Search as SearchIcon } from '@mui/icons-material';
import { IconButton, InputAdornment, Stack, TextField, ToggleButton, ToggleButtonGroup, Tooltip } from '@mui/material';

import { DomainGraphNodeFilter } from '../DomainGraphUtils';

type DomainGraphToolbarProps = {
	enabledNodeFilters: DomainGraphNodeFilter[];
	searchText: string;
	onNodeFiltersChanged: (filters: DomainGraphNodeFilter[]) => void;
	onSearchTextChanged: (searchText: string) => void;
	onAutoLayout: () => void;
};

export default function DomainGraphToolbar({
	enabledNodeFilters,
	searchText,
	onNodeFiltersChanged,
	onSearchTextChanged,
	onAutoLayout,
}: DomainGraphToolbarProps) {
	return (
		<Stack direction="row" spacing={1} alignItems="center" sx={{ justifySelf: 'start', minHeight: 38 }}>
			<ToggleButtonGroup
				value={enabledNodeFilters}
				size="small"
				onChange={(_event: React.MouseEvent<HTMLElement>, nextFilters: DomainGraphNodeFilter[]) => onNodeFiltersChanged(nextFilters)}
				aria-label="Node type filters"
				sx={{
					'& .MuiToggleButton-root': {
						px: 1,
						py: 0.75,
						minHeight: 38,
						fontSize: 12,
						lineHeight: 1.2,
					},
				}}
			>
				<ToggleButton value="root" aria-label="Show aggregate roots">
					Root
				</ToggleButton>
				<ToggleButton value="entity" aria-label="Show entities">
					Entity
				</ToggleButton>
				<ToggleButton value="enum" aria-label="Show enums">
					Enum
				</ToggleButton>
			</ToggleButtonGroup>
			<TextField
				value={searchText}
				onChange={(event) => onSearchTextChanged(event.target.value)}
				size="small"
				placeholder="Search"
				aria-label="Search graph nodes"
				slotProps={{
					input: {
						startAdornment: (
							<InputAdornment position="start">
								<SearchIcon fontSize="small" />
							</InputAdornment>
						),
					},
				}}
				sx={{
					width: 220,
					'& .MuiInputBase-root': {
						height: 38,
					},
				}}
			/>
			<Tooltip title="Auto layout">
				<IconButton size="small" onClick={onAutoLayout} aria-label="Auto layout">
					<AutoLayoutIcon fontSize="small" />
				</IconButton>
			</Tooltip>
		</Stack>
	);
}
